var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
import Tag from '../../icons/Tag';
import { PromoCodeTypes } from '../../config';
import OtoSpinner from '../common/OtoSpinner';
var onlyFromApp = (React.createElement(React.Fragment, null,
    React.createElement("div", null, "Obecnie ten kod rabatowy jest dost\u0119pny tylko z aplikacji mobilnej."),
    React.createElement("div", null, "Pobierz aplikacj\u0119, aby cieszy\u0107 si\u0119 rabatem.")));
var knownPromoCodeErrorsToLabels = {
    cart_not_enough: 'Zbyt mała wartość koszyka, aby użyć podany kod rabatowy',
    customer_required: onlyFromApp,
    expired: 'Podany kod nie jest już aktywny',
    invalid: 'Podany kod nie istnieje',
    invalid_source: onlyFromApp,
    invalid_weekday: 'Nie udało się wykorzystać kod - nieprawidłowy dzień tygodnia',
    only_for_new_customers: 'Ten kod rabatowy można wykorzystać tylko przy pierwszym zamówieniu',
    used: 'Podany kod został wykorzystany',
};
var PromoCode = /** @class */ (function (_super) {
    __extends(PromoCode, _super);
    function PromoCode(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.toggleInput = function () { return _this.setState({ showInput: !_this.state.showInput }); };
        _this.clearPromoCode = function (e) {
            _this.props.handler('');
            _this.setState({
                inputValue: '',
                loading: false,
                errorText: null,
                successText: null,
            });
        };
        _this.applyPromoCode = function () {
            var inputValue = _this.state.inputValue;
            _this.setState({
                loading: true,
                errorText: null,
                successText: null,
            });
            return _this.props
                .handler(inputValue.replace('#', ''))
                .then(function (_a) {
                var _b = __read(_a, 2), acceptedCode = _b[0], reasonToReject = _b[1];
                if (!!reasonToReject) {
                    if (reasonToReject === 'customer_required') {
                        return _this.props.verifyCustomer(_this.applyPromoCode, _this.handleCustomerVerificationFail);
                    }
                    return _this.rejectPromoCode(knownPromoCodeErrorsToLabels[reasonToReject] ||
                        'Niestety kod rabatowy nieprawidłowy, spróbuj jeszcze raz :)');
                }
                return _this.setState({
                    loading: false,
                    successText: getValidPromoCodeText(acceptedCode),
                    errorText: null,
                });
            })
                .catch(function (e) {
                return _this.rejectPromoCode('Wystąpił problem podczas sprawdzania kodu rabatowego');
            });
        };
        _this.handleCustomerVerificationFail = function () {
            return _this.setState({
                loading: false,
            });
        };
        _this.rejectPromoCode = function (message) {
            _this.props.handler(null);
            _this.setState({
                loading: false,
                errorText: message,
                successText: null,
            });
        };
        _this.updatePromoCodeValue = function (e) { return _this.setState({ inputValue: e.target.value }); };
        _this.onKeyPress = function (e) {
            var keycode = e.keyCode || e.which;
            if (keycode == '13') {
                e.preventDefault();
                e.stopPropagation();
                _this.applyPromoCode();
            }
        };
        _this.state = {
            errorText: null,
            loading: false,
            inputValue: (typeof props.promoCode === 'string'
                ? props.promoCode
                : (_a = props === null || props === void 0 ? void 0 : props.promoCode) === null || _a === void 0 ? void 0 : _a.promoCode) || '',
            successText: props.promoCode
                ? getValidPromoCodeText(props.promoCode)
                : '',
            showInput: !!props.promoCode,
        };
        return _this;
    }
    PromoCode.prototype.render = function () {
        var _a = this.state, errorText = _a.errorText, inputValue = _a.inputValue, loading = _a.loading, showInput = _a.showInput, successText = _a.successText;
        return (React.createElement("div", { className: "col-12" }, showInput ? (React.createElement("div", { className: "row mx-0" },
            successText ? (React.createElement("button", { type: "button", className: "btn btn-primary mb-2", onClick: this.clearPromoCode }, "Usu\u0144 kod")) : (React.createElement(React.Fragment, null,
                React.createElement("input", { className: "form-control w-auto mr-2 mb-2", placeholder: "Podaj kod rabatowy", value: inputValue, onKeyPress: this.onKeyPress, onChange: this.updatePromoCodeValue }),
                React.createElement("button", { type: "button", className: "btn btn-primary mb-2", onClick: this.applyPromoCode }, "U\u017Cyj"))),
            React.createElement("div", { className: "col-12 small px-0 mb-2" }, loading ? (React.createElement(OtoSpinner, null)) : (React.createElement(React.Fragment, null,
                successText && (React.createElement("div", { className: "text-success" }, successText)),
                errorText && React.createElement("div", { className: "text-danger" }, errorText)))))) : (React.createElement("button", { className: "btn btn-link pl-0 pt-0", type: "button", onClick: this.toggleInput },
            React.createElement(Tag, null),
            " ",
            React.createElement("span", { className: "ml-2" }, "Mam Kod Rabatowy")))));
    };
    return PromoCode;
}(React.PureComponent));
function getValidPromoCodeText(promoCode) {
    if (!promoCode) {
        return null;
    }
    // TODO migrate this later back to use object and not string
    // TODO - use basket status hint
    if (typeof promoCode === 'string') {
        return "U\u017Cyto kodu rabatowego ".concat(promoCode);
    }
    var discountValue = promoCode.discountValue, discountType = promoCode.discountType;
    if ([PromoCodeTypes.percent, PromoCodeTypes.value].includes(discountType)) {
        var unit = discountType === PromoCodeTypes.percent ? '%' : 'zł.';
        return "Naliczono rabat ".concat(discountValue).concat(unit, " od kwoty ca\u0142ego zam\u00F3wienia");
    }
    else if (discountType === PromoCodeTypes.freeDelivery) {
        return 'Dowieziemy twoje jedzienie za darmo ;)';
    }
    return null;
}
export default PromoCode;
